import { render, staticRenderFns } from "./shangpin.vue?vue&type=template&id=6fc666f6"
import script from "./shangpin.vue?vue&type=script&lang=js"
export * from "./shangpin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports